<template>
    <div>
        <template
            v-for="(property, index) in properties_object"
        >
            <v-divider
                v-if="index !== 0"
                class="mx-4"
            ></v-divider>

            <summary-breakdown
                class="py-3 px-4"
                :object="benefits"
                :property="property"
                :key="'property-' + index"
                :small="small"
            ></summary-breakdown>
        </template>

        <v-divider></v-divider>

        <template
            v-for="(property, index) in properties"
        >
            <summary-value
                :key="index"
                class="py-3 px-4"
                :object="benefits"
                :property="property"
                :small="small"
                :greyed="isGreyed(property)"
                :inverted="isInverted(property)"
                :append-label="getLppLabel(client.lpp_type)"
            ></summary-value>

            <v-divider></v-divider>
        </template>
    </div>
</template>

<script>
    import SummaryValue from "../../../Global/SummaryValue";
    import SummaryBreakdown from "../../../Global/SummaryBreakdown";

    import MyCoverMixin from "../../mycover";

    export default {
        name: 'My-Cover-Summary-Summary',

        components: {
            SummaryValue,
            SummaryBreakdown
        },

        mixins: [
            MyCoverMixin
        ],

        props: {
            'mobile': {
                type: Boolean,
                default: false,
            },
            'small': {
                type: Boolean,
                default: false,
            }
        },

        data() {
            return {
                properties_object: [
                    {
                        'label': 'LPP™ Benefits & Premium',
                        'values': [
                            'lppBenefits',
                            'lppMonthlyPremium'
                        ]
                    },
                    {
                        'label': 'MyCover™ Benefits & Premium',
                        'values': [
                            'totalMyCover',
                            'totalMyCoverPremium'
                        ]
                    }
                ],
                properties: [
                    'lppWithMyCoverBenefits',
                    'lppWithMyCoverPremiums'
                ],
            }
        },

        methods: {
            isGreyed(property) {
                return property === 'lppWithMyCoverBenefits';
            },
            isInverted(property) {
                return property === 'lppWithMyCoverPremiums';
            }
        }
    }
</script>
